import { render, staticRenderFns } from "./HoursLink.vue?vue&type=template&id=18a6d886&scoped=true"
import script from "./HoursLink.vue?vue&type=script&lang=js"
export * from "./HoursLink.vue?vue&type=script&lang=js"
import style0 from "./HoursLink.vue?vue&type=style&index=0&id=18a6d886&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a6d886",
  null
  
)

export default component.exports